import { render, staticRenderFns } from "./VenuesPage.vue?vue&type=template&id=35069953&scoped=true"
import script from "./VenuesPage.vue?vue&type=script&lang=ts"
export * from "./VenuesPage.vue?vue&type=script&lang=ts"
import style0 from "./VenuesPage.vue?vue&type=style&index=0&id=35069953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35069953",
  null
  
)

export default component.exports